import store from '@/store';
import debounce from '@/utils/Debounce';
import { computed, ref, onMounted, onUnmounted } from 'vue';

export default class Suggestions {
	containerRef = ref<HTMLElement | null>(null);
	listRef = ref<HTMLElement | null>(null);
	text = computed(() => store.getters.getText());
	suggestions = computed(() => store.getters.getSuggestions());

	constructor() {
		onMounted(() => {
			this.setupScrollListener();
		});

		onUnmounted(() => {
			this.removeScrollListener();
		});
	}

	private isMobileDevice(): boolean {
		return window.innerWidth <= 768;
	}

	private handleScroll = (): void => {
		if (!this.isMobileDevice()) return;
		const activeEl = document.activeElement as HTMLElement | null;
		if (!activeEl) return;

		activeEl.blur();
	};

	private handleScrollDebounced = debounce(this.handleScroll, 50);

	private setupScrollListener(): void {
		if (!this.isMobileDevice()) return;
		if (this.containerRef.value) {
			this.containerRef.value.addEventListener('scroll', this.handleScrollDebounced, { passive: true });
		}
	}

	private removeScrollListener(): void {
		if (this.containerRef.value) {
			this.containerRef.value.removeEventListener('scroll', this.handleScrollDebounced);
		}
	}

}